export default __webpack_public_path__ + "4a8bb3e73b9b1f2dc2fa28db09fc82bf.jpg";